export const IPAD_DEVICES = [
  // Original iPad (2010)
  "A1219", // iPad Wi-Fi
  "A1337", // iPad Wi-Fi + 3G

  // iPad 2 (2011)
  "A1395", // iPad 2 Wi-Fi
  "A1396", // iPad 2 Wi-Fi + 3G (GSM)
  "A1397", // iPad 2 Wi-Fi + 3G (CDMA)

  // iPad 3rd Generation (2012)
  "A1416", // iPad (3rd generation) Wi-Fi
  "A1430", // iPad (3rd generation) Wi-Fi + Cellular (Verizon)
  "A1403", // iPad (3rd generation) Wi-Fi + Cellular (GSM)

  // iPad 4th Generation (2012)
  "A1458", // iPad (4th generation) Wi-Fi
  "A1459", // iPad (4th generation) Wi-Fi + Cellular
  "A1460", // iPad (4th generation) Wi-Fi + Cellular (MM)

  // iPad Air (2013)
  "A1474", // iPad Air Wi-Fi
  "A1475", // iPad Air Wi-Fi + Cellular
  "A1476", // iPad Air Wi-Fi + Cellular (TD-LTE)

  // iPad Mini Series
  "A1432", // iPad Mini Wi-Fi
  "A1454", // iPad Mini Wi-Fi + Cellular
  "A1455", // iPad Mini Wi-Fi + Cellular (MM)
  "A1489", // iPad Mini 2 Wi-Fi
  "A1490", // iPad Mini 2 Wi-Fi + Cellular
  "A1599", // iPad Mini 3 Wi-Fi
  "A1600", // iPad Mini 3 Wi-Fi + Cellular
  "A1538", // iPad Mini 4 Wi-Fi
  "A1550", // iPad Mini 4 Wi-Fi + Cellular
  "A2133", // iPad Mini (5th generation) Wi-Fi
  "A2124", // iPad Mini (5th generation) Wi-Fi + Cellular
  "A2567", // iPad Mini (6th generation) Wi-Fi
  "A2568", // iPad Mini (6th generation) Wi-Fi + Cellular

  // iPad Pro Series
  "A1584", // iPad Pro 12.9-inch Wi-Fi
  "A1652", // iPad Pro 12.9-inch Wi-Fi + Cellular
  "A1673", // iPad Pro 9.7-inch Wi-Fi
  "A1674", // iPad Pro 9.7-inch Wi-Fi + Cellular
  "A1876", // iPad Pro 12.9-inch (3rd generation) Wi-Fi
  "A1980", // iPad Pro 11-inch (1st generation) Wi-Fi
  "A2378", // iPad Pro 12.9-inch (5th generation) Wi-Fi
  "A2461", // iPad Pro 12.9-inch (5th generation) Wi-Fi + Cellular
  "A2377", // iPad Pro 11-inch (3rd generation) Wi-Fi
  "A2459", // iPad Pro 11-inch (3rd generation) Wi-Fi + Cellular

  // iPad (5th to 10th Generation)
  "A1822", // iPad (5th generation) Wi-Fi
  "A1823", // iPad (5th generation) Wi-Fi + Cellular
  "A1893", // iPad (6th generation) Wi-Fi
  "A1954", // iPad (6th generation) Wi-Fi + Cellular
  "A2197", // iPad (7th generation) Wi-Fi
  "A2200", // iPad (7th generation) Wi-Fi + Cellular
  "A2270", // iPad (8th generation) Wi-Fi
  "A2428", // iPad (8th generation) Wi-Fi + Cellular
  "A2602", // iPad (9th generation) Wi-Fi
  "A2604", // iPad (9th generation) Wi-Fi + Cellular
  "A2757", // iPad (10th generation) Wi-Fi
  "A2761", // iPad (10th generation) Wi-Fi + Cellular
];
